<template>
  <div class="moduleStyle minHeight">
    <pageTitle title="供应商管理">
      <template v-if="hasPermission('配置-供应商管理-新增')">
        <el-button
          size="small"
          type="primary"
          @click="newlyAdded"
          icon="el-icon-plus"
          >新增供应商</el-button
        >
      </template>
    </pageTitle>
    <basicList
      :config="basicListconfig"
      @search="searchEvent"
      @sortChange="sortChange"
    >
      <template v-slot:operation="row">
        <div style="display: flex; align-items: center">
          <template v-if="hasPermission('配置-供应商管理-编辑')">
            <div class="button button_modify" @click="editButton(row.row)">
              <i class="iconfont icon-bianji"></i> 编辑
            </div>
          </template>

          <div class="button button_revoke" @click="supplyList(row.row)">
            <i class="iconfont icon-qingdan"></i> 供货清单
          </div>

          <template v-if="hasPermission('配置-供应商管理-编辑')">
            <div class="button button_revoke" @click="switchingStates(row.row)">
              <i
                :class="
                  row.row.status == 0
                    ? 'iconfont icon-lock'
                    : 'iconfont icon-jihuo'
                "
              ></i
              >{{ row.row.status == 0 ? "锁定" : "激活" }}
            </div>
          </template>

          <div class="button button_revoke" @click="transferAccounts(row.row)">
            <i class="iconfont icon-zhuanzhang"></i> 转账
          </div>

          <template v-if="hasPermission('配置-供应商管理-删除')">
            <div class="button button_revoke" @click="deleteRows(row.row)">
              <i class="iconfont icon-shanchu"></i> 删除
            </div>
          </template>

          <!-- <el-popover
            :visible-arrow="false"
            placement="bottom"
            width="160"
            trigger="click"
          >
            <ul class="moreOperations">
              <li @click="locking(row.row)">
                <i class="iconfont icon-lock"></i> 锁定
              </li>
              <li @click="activation(row.row)">
                <i class="iconfont icon-jihuo"></i> 激活
              </li>
              <li @click="deleteRows(row.row)">
                <i class="iconfont icon-shanchu"></i> 删除
              </li>
            </ul>
            <div slot="reference" class="button button_more">
              <img src="../../assets/images/icon_more.png" />
            </div>
          </el-popover> -->
        </div>
      </template>
    </basicList>
    <formWindow
      :dialogParams="dialogParams"
      @close="closeThePopUpWindow"
    ></formWindow>
    <supplyList :dialogParams="supplyListParams" @close="closeSupply">
    </supplyList>

    <!-- 转账弹窗 -->
    <el-dialog
      custom-class="addProductPopUpWindow"
      title="转账"
      :visible.sync="transferVisible"
      width="550px"
    >
      <el-form
        ref="transferForm"
        :model="transferForm"
        :rules="transferRules"
        label-position="top"
      >
        <el-row :gutter="24">
          <el-col :span="24">
            <el-form-item label="金额" prop="money">
              <el-input
                v-model="transferForm.money"
                placeholder="请输入金额"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转出账户" prop="from_payid">
              <el-input
                v-model="transferForm.from_payid_name"
                disabled
                placeholder="转出账户"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="转入账户" prop="to_payid">
              <el-select
                v-model="transferForm.to_payid"
                style="width: 100%"
                size="small"
                filterable
                clearable
                placeholder="请选择资金账户"
              >
                <el-option
                  v-for="item in accountList_in"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                  <span style="float: left">
                    {{ item.label }}
                  </span>
                  <span style="float: right; color: #8492a6; font-size: 13px">
                    {{ "余额:" + item.money }}
                  </span>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="transferForm.remark"
                placeholder="请输入备注"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer">
        <el-button type="info" @click="transfercancel">取消</el-button>
        <el-button type="danger" @click="transferreset">重置</el-button>
        <el-button type="success" @click="transferadd">确认新增</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  supplierGetList,
  supplierDel,
  supplierActive,
  supplierLock,
} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
import { supplierToMoney } from "@/api/bill";
import { companyAccountGetList, userPermissionCompanyAccountGetList } from "@/api/purchasing";
import { validatorPrice } from "@/utils/validate.js";
const defaultParameters = {
  page: 1,
  limit: 10,
};
// 默认参数
export default {
  name: "supplierManagement",
  components: {
    formWindow: () => import("./formWindow.vue"),
    supplyList: () => import("./supplyList.vue"),
  },
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopId: null,

      // 弹窗参数
      dialogParams: {
        key: new Date().getTime(),
        visible: false,
        id: "",
      },
      // 供货清单参数
      supplyListParams: {
        key: new Date().getTime(),
        visible: false,
        id: 0,
      },
      // 列表组件参数
      basicListconfig: {
        loading: false,
        search: [
          {
            label: "编号",
            type: "inputNumber",
            key: "id",
            width: 100,
          },
          {
            label: "名称/昵称/电话",
            type: "input",
            key: "keywords",
          },
          {
            label: "类型",
            type: "select",
            key: "level",
            options: [
              {
                value: 0,
                label: "普通供应商",
              },
              {
                value: 4, // 为什么是4 ，是为了和客户类型 4 保持一致
                label: "散户供应商",
              },
              {
                value: 1,
                label: "特殊供应商",
              },
            ],
          },
          {
            label: "状态",
            key: "status",
            type: "select",
            options: [
              {
                label: "启用",
                value: 1,
              },
              {
                label: "禁用",
                value: 2,
              },
            ],
          },
        ],
        data: [],
        column: [
          {
            label: "编号",
            prop: "id",
            width: 100,
          },
          {
            label: "名称",
            prop: "name",
            width: 200,
          },
          {
            label: "昵称",
            prop: "nick_nameEx",
            width: 200,
          },
          {
            label: "类型",
            prop: "level",
            filter: "supplierLevel",
            sortable: true,
            width: 100,
          },
          {
            label: "余额",
            prop: "money",
            isMoney: true,
            sortable: true,
          },
          {
            label: "最近供货时间",
            prop: "supplier_time",
            sortable: true,
            width: 200,
          },
          {
            label: "电话",
            prop: "contact_tel",
          },
          {
            label: "地址",
            prop: "contact_address",
          },
          {
            label: "状态",
            prop: "status",
            sortable: true,
            filter: "storeStatus",
          },
        ],
        operationWidth: 410,
        isPage: true,
        total: 0,
        searchParameters: Object.assign({}, defaultParameters),
      },
      // 转账相关
      transferVisible: false,
      transferForm: {
        money: "",
        from_payid: "",
        from_payid_name: "",
        to_payid: "",
        remark: "",
        user_id: "",
        comp_id: "",
        sup_id: "",
        account_id: ""
      },
      accountList_in: [],
      transferRules: {
        money: [
          {
            validator: validatorPrice,
            message: "请输入正确金额",
            trigger: "blur",
          },
          {
            required: true,
            message: "此项是必填项",
            trigger: "change",
          },
        ],
        to_payid: {
          required: true,
          message: "此项是必填项",
          trigger: "change",
        },
      },
    };
  },
  created() {
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    this.shopId = this.$store.getters.userInfo.shopId;

    // 初始化列表内容
    this.getlist();
    // 获取账户列表
    this.getAccountList();
  },
  computed: {
    ...mapGetters(["hasPermission"]),
  },
  methods: {
    sortChange(data) {
      this.basicListconfig.searchParameters.page = 1;
      this.basicListconfig.searchParameters.order_column = data.prop;
      this.basicListconfig.searchParameters.order_up =
        data.order == "ascending" ? 1 : data.order == "descending" ? 0 : "";
      this.getlist();
    },
    switchingStates(row) {
      if (row.status == 0) {
        this.locking(row);
      } else {
        this.activation(row);
      }
    },
    // 供货清单
    supplyList(row) {
      this.supplyListParams.visible = true;
      this.supplyListParams.key = new Date().getTime();
      this.supplyListParams.id = row.id;
      this.supplyListParams.title = row.name;
    },
    // 锁定方法
    locking(row) {
      this.$confirm("是否确认锁定?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        supplierLock({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 激活方法
    activation(row) {
      this.$confirm("是否确认激活?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        supplierActive({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除方法
    deleteRows(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        supplierDel({
          id: row.id,
          comp_id: JSON.parse(getRoles()).comp_id,
        }).then((res) => {
          if (res.code == 1) {
            this.$message.success("删除成功");
            this.getlist();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 关闭弹窗
    closeThePopUpWindow() {
      this.dialogParams.visible = false;
      this.dialogParams.key = new Date().getTime();
      this.getlist();
    },
    closeSupply() {
      this.supplyListParams.visible = false;
      this.supplyListParams.key = new Date().getTime();
    },
    // 编辑弹窗
    editButton(row) {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = row.id;
    },
    // 新增事件
    newlyAdded() {
      this.dialogParams.key = new Date().getTime();
      this.dialogParams.visible = true;
      this.dialogParams.id = "";
    },
    // 搜索事件
    searchEvent(data, page, pageSize) {
      if (page || pageSize) {
        if (page) this.basicListconfig.page = page;
        if (pageSize) this.basicListconfig.searchParameters.limit = pageSize;
        this.getlist();
      } else if (data) {
        for (const key in data) {
          this.basicListconfig.searchParameters[key] = data[key];
        }
        this.basicListconfig.searchParameters.page = 1;
        this.getlist();
      }
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      this.basicListconfig.searchParameters.comp_id = JSON.parse(
        getRoles()
      ).comp_id;
      this.basicListconfig.searchParameters.user_id = this.userId;
      this.basicListconfig.searchParameters.is_showAll = 1;
      supplierGetList(this.basicListconfig.searchParameters).then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.basicListconfig.data = res.data;
          this.basicListconfig.total = res.count;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    // 获取账户列表
    getAccountList() {
      if (this.roleId == 4) {
        // 收款
        userPermissionCompanyAccountGetList({
          comp_id: this.compId,
          user_id: this.userId,
          op_type: 1, // 0 查看 1 收款 2 付款
        }).then((res) => {
          if (res.code == 1) {
            this.accountList_in = res.data.map((item) => {
              return {
                label: item.account_name,
                value: item.account_id,
                money: this.$money(item.money),
              };
            });
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });
      } else {
        companyAccountGetList({
          comp_id: this.compId,
          limit: 10000,
          status: 0,
        }).then((res) => {
          if (res.code == 1) {
            this.accountList_in = res.data.map((item) => {
              return {
                label: item.account_name,
                value: item.id,
                money: this.$money(item.money),
              };
            });
          } else {
            this.$message.error(res.data.msg || "获取资金账户列表数据源失败！");
          }
        });
      }
    },
    // 转账按钮点击事件
    transferAccounts(row) {
      this.transferVisible = true;
      this.transferForm = {
        money: this.$money(row.money),
        from_payid: row.id,
        from_payid_name: row.name + " 供应商余额账户",
        to_payid: "",
        remark: "",
        user_id: this.userId,
        comp_id: this.compId,
        sup_id: row.id,
        account_id: ""
      };
    },
    // 转账取消
    transfercancel() {
      this.transferreset();
      this.transferVisible = false;
    },
    // 转账重置
    transferreset() {
      this.transferForm = {
        money: "",
        from_payid: "",
        from_payid_name: "",
        to_payid: "",
        remark: "",
        user_id: "",
        comp_id: "",
        sup_id: "",
        account_id: ""
      };
    },
    // 转账确认
    transferadd() {
      this.$refs["transferForm"].validate((valid) => {
        if (valid) {
          // 设置account_id为选中的to_payid
          this.transferForm.account_id = this.transferForm.to_payid;
          supplierToMoney(this.transferForm).then((res) => {
            if (res.code == 200) {
              this.$message.success(res.msg);
              this.transfercancel();
              this.getlist();
            } else if (res.code == 0) {
              this.$message.error(res.msg);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/supplierManagement/index.vue